/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveSectionSchema } from "./reserveSectionSchema.ts";

export const orgUnitReserveSectionsListPathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveSectionsListStatus200Schema = z.array(reserveSectionSchema);

export const orgUnitReserveSectionsListResponseSchema = orgUnitReserveSectionsListStatus200Schema;
